// extracted by mini-css-extract-plugin
module.exports = {"linksWrapper":"SocialLinks_linksWrapper__2gDGe","links":"SocialLinks_links__3COlj"};